
<template>
  <div class="sorry-message-wrapper">
    <div class="sorry-message">
      <p>Sorry! Multi-currency support is not yet available.</p>
      <p>We are working hard to bring this to you as soon as possible.</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">
.sorry-message-wrapper {
  height: 100%;
}

.sorry-message {
  position: absolute;
  top: 50%;
  width: 100%;
  margin: 0;
  font-size: 15px;
  text-align: center;
  transform: translateY(-50%);
}
</style>
